import { Alert } from '@ver-uds/uswds-react';
import { HiringSite } from 'eve-account-client';
import React from 'react';
import { CSVLink } from 'react-csv';
import { ValidationResult } from './HiringSiteValidator';
import FormVariant from '../../Enrollment/FormVariant';
import InternalRoutes from '../../../constants/InternalRoutes';

export type UploadErrorsProps = {
  variant: FormVariant;
  uploadErrors?: HiringSite[];
  uploadResults?: ValidationResult;
};

const UploadErrors = ({ variant, uploadErrors, uploadResults }: UploadErrorsProps): JSX.Element => {
  const headers = [
    { label: 'Street Address', key: 'line1' },
    { label: 'Suite/Other', key: 'line2' },
    { label: 'City', key: 'city' },
    { label: 'State', key: 'stateCode' },
    { label: 'Zip Code', key: 'zipCode' },
  ];

  // in order to prevent extra error messages from showing, we only show the server side error message if there
  // are valid sites present or if there's no client side error messages
  const showServerSideErrorMessage =
    variant === FormVariant.EDIT &&
    uploadResults?.errorMessage &&
    (uploadResults.validSites?.length > 0 || uploadErrors?.length === 0);

  return (
    <div className="grid-col-12 desktop:grid-col-9 margin-top-4 ">
      {uploadResults && uploadResults.validSites.length > 0 && (
        <Alert status="success" slim>
          <Alert.Text>
            {uploadResults.validSites.length === 1
              ? 'One hiring site has'
              : `${uploadResults.validSites.length} hiring sites have`}{' '}
            successfully been added below.
          </Alert.Text>
        </Alert>
      )}
      {uploadErrors && uploadErrors.length > 0 && (
        <Alert status="error" slim>
          <Alert.Text>
            {uploadErrors.length === 1 ? 'One error' : `${uploadErrors.length} errors`} found.{' '}
            <CSVLink filename="Hiring Sites Bulk Upload Errors" headers={headers} data={uploadErrors}>
              Export Errors
            </CSVLink>{' '}
            to download CSV rows with missing or invalid field data.{' '}
            <a
              href={InternalRoutes.CSV_GUIDELINES}
              rel="noopener noreferrer"
              target="_blank"
              aria-label="Learn more about Bulk Upload CSV Guidelines in a new tab"
            >
              Learn More.
            </a>
          </Alert.Text>
        </Alert>
      )}
      {showServerSideErrorMessage && (
        <Alert status="error" slim>
          <Alert.Text>{uploadResults?.errorMessage}</Alert.Text>
        </Alert>
      )}
    </div>
  );
};
export default UploadErrors;
